import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import Api from "./api/api";

Vue.use(ElementUI);

//添加事件总线对象,用于兄弟组件通信
Vue.prototype.$bus = new Vue();

Vue.config.productionTip = false;
Vue.prototype.$api = Api;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
